import { APPLICATION_INVENTORY } from './inventory';
import { PAGE_PURPOSES } from './purposes';
import { RESEARCH_GUIDES } from '../guides/research';


export const APPLICATION_PAGES = APPLICATION_INVENTORY.map((page) => {
	const reviewed = RESEARCH_GUIDES.find((guide) => guide.route === page.route);
	return {
		...page,
		purpose: reviewed?.purpose || PAGE_PURPOSES[page.route] || '',
		reviewed,
		// Dynamic routes require actual record identifiers; never suggest placeholders as links.
		navigable: !page.route.includes(':') && !['/not-found', '/ui-foundation-preview', '/user/verify-success'].includes(page.route)
	};
});
